import { Box, Icon } from '@mui/material';
import React, { memo } from 'react';

export const contentStyle: { [key: string]: React.CSSProperties } = {
  contentHeader: {
    padding: '8px 0px',
    flexGrow: 1,
    backgroundColor: '#eee',
    textAlign: 'center' 
  },
  io: {
    position: 'relative',
    padding: '8px 16px',
    flexGrow: 1,
  },
  left: { left: '-8px' },
  textLeft: { textAlign: 'left' },
  right: { right: '-8px' },
  textRight: { textAlign: 'right' },
  handle: {
    width: '10px',
    height: '10px',
    margin: 'auto',
    background: '#ddd',
    borderRadius: '15px',
    border: '1px solid #222138',
    boxShadow:
      'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px'
  }
};

const style: { [key: string]: React.CSSProperties } = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    border: '1px solid #222138',
    fontSize: '10pt',
    borderRadius: '12px 12px',
    width: 140,
  },
  selected: {
    boxShadow: '0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)',
    border: '2px solid #000000'
  },
  title: {
    position: 'relative',
    padding: '8px 8px',
    flexGrow: 1,
    backgroundColor: '#eee',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '15px',
    marginLeft: '15px'
  },
  contentWrapper: {
    padding: '8px 0px'
  }
};

interface NodeProps {
  label: string;
  selected: boolean;
  color?: string;
  content: React.ReactNode;
  icon:string;
  colorIcon?: string;
  
}
const Node: React.FC<NodeProps> = ({
  label,
  selected,
  color,
  content,
  icon,
}: NodeProps) => {
  const customTitle = { ...style.title };
  if (color) customTitle.backgroundColor = color;

  const customBody = { ...style.body };
  if (selected) {
    customBody.boxShadow = style.selected.boxShadow;
    customBody.border = style.selected.border;
  }

  // Collapse contentWrapper on icon click
  return (
    <Box style={customBody}>
      <Box style={customTitle}>
        <Icon style={style.icon}>{icon}</Icon>
        {label}
      </Box>
      <Box style={style.contentWrapper}>{content}</Box>
    </Box>
  );
};

export default memo(Node);
